module.exports = __webpack_public_path__ + "img/power-off-gray.8b770018.svg";